import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface SideNavState {
    openSideMenu: boolean;
}

const initialState: SideNavState = {
    openSideMenu: false
}

const sideNavSlice = createSlice({
    name: 'sideNav',
    initialState,
    reducers: {
        updateOpenSideMenu: (state, action: PayloadAction<boolean>) => {
            state.openSideMenu = action.payload;
        }
    }
});

export const { updateOpenSideMenu } = sideNavSlice.actions;
export default sideNavSlice.reducer;